import React from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { OrdenCompra } from '../../services/ordenCompraService';
import { formatDateTime } from '../../utils/formatters';
import { esOrdenCompraAprobada } from '../../utils/ordenCompraAprobacion';

interface OrdenCompraAprobacionIndicadorProps {
  orden: Pick<OrdenCompra, 'fechaAprobacion' | 'usuarioAprobacion'>;
}

const OrdenCompraAprobacionIndicador: React.FC<OrdenCompraAprobacionIndicadorProps> = ({ orden }) => {
  if (!esOrdenCompraAprobada(orden)) {
    return (
      <Typography variant="body2" color="text.secondary">
        -
      </Typography>
    );
  }

  const fecha = formatDateTime(orden.fechaAprobacion);
  const usuario = (orden.usuarioAprobacion ?? '').trim();
  const tooltip = `Aprobada el ${fecha}${usuario ? ` por ${usuario}` : ''}`;

  return (
    <Tooltip title={tooltip}>
      <Stack direction="row" alignItems="center" spacing={0.5} component="span" sx={{ display: 'inline-flex' }}>
        <CheckCircleIcon fontSize="small" color="success" />
        <Typography variant="body2" component="span" sx={{ whiteSpace: 'nowrap' }}>
          {fecha}
        </Typography>
      </Stack>
    </Tooltip>
  );
};

export default OrdenCompraAprobacionIndicador;
